var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configData && _vm.configData.list
    ? _c(
        "div",
        { staticClass: "home-comb-cards borderPadding" },
        [
          _vm.configData.title
            ? _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.configData.title)),
              ])
            : _vm._e(),
          _vm._l(_vm.configData.list, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "card-box" },
              [
                _c(
                  "div",
                  { staticClass: "card-head" },
                  [
                    _c("div", { staticClass: "card-name" }, [
                      _vm._v(_vm._s(_vm.cardLabel(item, index))),
                    ]),
                    _c("el-switch", {
                      attrs: {
                        "active-value": true,
                        "inactive-value": false,
                        "active-text": "显示",
                        "inactive-text": "隐藏",
                      },
                      model: {
                        value: item.status,
                        callback: function ($$v) {
                          _vm.$set(item, "status", $$v)
                        },
                        expression: "item.status",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "form-row" },
                  [
                    _c("span", [_vm._v("标题")]),
                    _c("el-input", {
                      attrs: { size: "small", maxlength: "10" },
                      model: {
                        value: item.title,
                        callback: function ($$v) {
                          _vm.$set(item, "title", $$v)
                        },
                        expression: "item.title",
                      },
                    }),
                  ],
                  1
                ),
                item.type === "stats"
                  ? _vm._l(item.stats, function (metric, metricIndex) {
                      return _c(
                        "div",
                        { key: metricIndex, staticClass: "metric-box" },
                        [
                          _c(
                            "div",
                            { staticClass: "metric-head" },
                            [
                              _c("div", [
                                _vm._v("数据项 " + _vm._s(metricIndex + 1)),
                              ]),
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                  "active-text": "显示",
                                  "inactive-text": "隐藏",
                                },
                                model: {
                                  value: metric.status,
                                  callback: function ($$v) {
                                    _vm.$set(metric, "status", $$v)
                                  },
                                  expression: "metric.status",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c("span", [_vm._v("名称")]),
                              _c("el-input", {
                                attrs: { size: "small", maxlength: "6" },
                                model: {
                                  value: metric.label,
                                  callback: function ($$v) {
                                    _vm.$set(metric, "label", $$v)
                                  },
                                  expression: "metric.label",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c("span", [_vm._v("数值")]),
                              _c("el-input", {
                                attrs: { size: "small", maxlength: "12" },
                                model: {
                                  value: metric.value,
                                  callback: function ($$v) {
                                    _vm.$set(metric, "value", $$v)
                                  },
                                  expression: "metric.value",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "form-row align-start" }, [
                            _c("span", [_vm._v("图标")]),
                            _c("div", { staticClass: "icon-upload-box" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "icon-image-box",
                                  on: {
                                    click: function ($event) {
                                      return _vm.pickMetricIcon(metric)
                                    },
                                  },
                                },
                                [
                                  metric.iconImage
                                    ? _c("img", {
                                        attrs: {
                                          src: metric.iconImage,
                                          alt: "",
                                        },
                                      })
                                    : _c(
                                        "div",
                                        { staticClass: "upload-placeholder" },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "iconfont icon-tianjia1",
                                          }),
                                        ]
                                      ),
                                  metric.iconImage
                                    ? _c("span", {
                                        staticClass:
                                          "iconfont-diy iconfont icon-tianjia1 delete-icon",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.clearMetricIcon(metric)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _c("div", { staticClass: "icon-tips" }, [
                                _vm._v(
                                  "建议上传透明底小图标，默认尺寸接近正方形。"
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      )
                    })
                  : [
                      _c(
                        "div",
                        { staticClass: "form-row align-start" },
                        [
                          _c("span", [_vm._v("描述")]),
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              maxlength: "40",
                              "show-word-limit": "",
                            },
                            model: {
                              value: item.desc,
                              callback: function ($$v) {
                                _vm.$set(item, "desc", $$v)
                              },
                              expression: "item.desc",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-row" },
                        [
                          _c("span", [_vm._v("按钮")]),
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              maxlength: "6",
                              placeholder: "留空则不显示按钮",
                            },
                            model: {
                              value: item.buttonText,
                              callback: function ($$v) {
                                _vm.$set(item, "buttonText", $$v)
                              },
                              expression: "item.buttonText",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "form-row" }, [
                        _c("span", [_vm._v("链接")]),
                        _c(
                          "div",
                          {
                            staticClass: "link-box",
                            on: {
                              click: function ($event) {
                                return _vm.pickLink(index)
                              },
                            },
                          },
                          [
                            _c(
                              "el-input",
                              {
                                attrs: {
                                  size: "small",
                                  readonly: "",
                                  placeholder: "请选择跳转链接",
                                },
                                model: {
                                  value: item.url,
                                  callback: function ($$v) {
                                    _vm.$set(item, "url", $$v)
                                  },
                                  expression: "item.url",
                                },
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    slot: "append",
                                    icon: "el-icon-arrow-right",
                                  },
                                  slot: "append",
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      item.layout === "secondary"
                        ? _c("div", { staticClass: "form-row align-start" }, [
                            _c("span", [_vm._v("徽标")]),
                            _c("div", { staticClass: "icon-upload-box" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "icon-image-box",
                                  on: {
                                    click: function ($event) {
                                      return _vm.pickBadgeImage(item)
                                    },
                                  },
                                },
                                [
                                  item.badgeImage
                                    ? _c("img", {
                                        attrs: {
                                          src: item.badgeImage,
                                          alt: "",
                                        },
                                      })
                                    : _c(
                                        "div",
                                        { staticClass: "upload-placeholder" },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "iconfont icon-tianjia1",
                                          }),
                                        ]
                                      ),
                                  item.badgeImage
                                    ? _c("span", {
                                        staticClass:
                                          "iconfont-diy iconfont icon-tianjia1 delete-icon",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.clearBadgeImage(item)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _c("div", { staticClass: "icon-tips" }, [
                                _vm._v(
                                  "建议上传透明底小图标，默认尺寸接近正方形。"
                                ),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                    ],
              ],
              2
            )
          }),
          _c("linkaddress", {
            ref: "linkaddres",
            on: { linkUrl: _vm.linkUrl },
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }